import React, {useState} from 'react';
import styled from "styled-components"
import Hamburger from "./Hamburger";
import logo from "../assets/logo.png";
import arrow from "../assets/arriow.svg";
import {Link, NavLink} from "react-router-dom";
import {device} from "../device";
import {withRouter} from "react-router";
import SignUpForm from "./SignUpForm";
import {Connect} from "./Connect";

const Wrapper = styled.div`
position:absolute;
top:0;
left:0;
width:100%;
min-height:80px;
display: flex;
justify-content: space-between;
align-items: center;
z-index: 9999;




@media ${device.laptop} {
width:100%;
padding: 0 5rem;
}



`

const LogoContainer = styled(Link)`
display: flex;
justify-content: start;
align-items: center;
font-size: 2.5rem;
width: 190px;
padding-top: .7rem;
text-decoration: none;
padding-left: 1rem;
img {
width: 70px;
margin-right: 1rem;
}

@media ${device.mobileL} {
font-size: 3rem;
justify-content: center;
}



`
const SocialContainer = styled.div`
position:absolute;
height: 70px;
bottom:-70px;
left:20px;
display: none;
flex-direction: column;
justify-content: center;
align-items: center;
`

const StyledNavLink = styled(NavLink)`
color:#6e306b;
font-size: 2rem;
margin:0 3rem ;
text-decoration: none;
transition: .2s all ease-in-out;
text-transform: uppercase;


&:hover {
        cursor: pointer;
        opacity: .5;
        transition: .2s all ease-in-out;
        
        img {
            transform: rotate(180deg);
            transition: .2s all ease-in-out;

          } 
    }
`

const Navigation = styled.div`
display: none;
justify-content: center;
align-items: center;

@media ${device.laptop} {
display: flex;
}

.active {
opacity:.4;
}




.socials, span {
position:relative;
color:#6e306b;
font-size: 2rem;
margin:0 3rem ;
text-decoration: none;
transition: .2s all ease-in-out;
text-transform: uppercase;

img {
width:13px;
height: 13px;
transition: .2s all ease-in-out;
}

&:hover {
        cursor: pointer;
        transition: .2s all ease-in-out;
        
        ${SocialContainer} {
          display: flex;
        }
        
        
        img {
            transform: rotate(180deg);
            transition: .2s all ease-in-out;

          } 
    }
}
}
    
.notlink {
&:hover {
        opacity: 0.5;
    }
}

`

const SocialItem = styled.a`
margin:.5rem 0;


&:hover {
text-decoration: underline;
}
`

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color:#6e306b;
  font-size: 2.4rem;
  span {
    margin: 0 .5rem ;
  }

`


const Navbar = ({location}) => {
    const [isMenuActive, setMenuActive] = useState(false)
    const [isLoginModalOpen, setLoginModalOpen] = useState(false)

    return (
        <>
            <Wrapper>
                <LogoContainer to="/"><img src={logo} alt=""/></LogoContainer>
                <Navigation>
                    <StyledNavLink to="/" exact activeClassName="active">Home</StyledNavLink>
                    <StyledNavLink to="/Loans" exact activeClassName="active">Loans</StyledNavLink>
                    <StyledNavLink to="/Staking" exact activeClassName="active">Staking</StyledNavLink>
                    <span className="socials">Socials <img src={arrow} alt="arrow"/>
                        <SocialContainer>
                            <SocialItem>
                                Twitter
                            </SocialItem>
                             <SocialItem>
                                Telegram
                            </SocialItem>
                        </SocialContainer>
                    </span>
                    <LoginContainer>
                        <span className="notlink" onClick={() => setLoginModalOpen(!isLoginModalOpen)}>Sign Up /Kyc</span>
                    </LoginContainer>
                    <Connect/>
                    <SignUpForm isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen}/>

                </Navigation>
                <Hamburger isMenuActive={isMenuActive}
                           setMenuActive={setMenuActive}
                           isLoginModalOpen={isLoginModalOpen}
                           setLoginModalOpen={setLoginModalOpen}
                           secondary/>
            </Wrapper>


        </>
    );
};

export default withRouter(Navbar);